import React from 'react';

const Point = ({ size, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 4 4" fill={color}>
    <circle cx="2" cy="2" r="2" />
  </svg>
);

export default Point;
